import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TasksTabContainer = styled(Stack)(() => ({
  gap: '0.25rem',
  paddingTop: '0.25rem',
  minHeight: 0,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

export const SectionsContainer = styled(Stack)(() => ({
  gap: '0.5rem',
  flex: 1,
}));
